import * as Yup from "yup"
import i18n from "../../../../app/i18n"

export const exportChatValidation = (): Yup.AnyObjectSchema => {
  return Yup.object().shape({
    summary: Yup.string()
      .trim()
      .required(i18n.t("shared:required"))
      .max(100, i18n.t("shared:maxLengthExceeded", { maxLength: 100 })),
    assetIds: Yup.array()
      .required(i18n.t("shared:required"))
      .min(1, i18n.t("shared:mustSelectAtLeastOne")),
  })
}
